import { render, staticRenderFns } from "./nomination-matrix.vue?vue&type=template&id=89e61a28&scoped=true"
import script from "./nomination-matrix.vue?vue&type=script&lang=js"
export * from "./nomination-matrix.vue?vue&type=script&lang=js"
import style0 from "./nomination-matrix.vue?vue&type=style&index=0&id=89e61a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e61a28",
  null
  
)

export default component.exports